import { useEffect } from 'react';

import { useMap } from '@domain/map/MapContext';
import { useExplore } from '../../../views/Explore/context/ExploreContext';

export function useMapResize(): void {
  const {
    exploreQueryParams: { drawerView },
  } = useExplore();
  const isDrawerOpened = drawerView !== undefined;
  const { map } = useMap();

  useEffect(() => {
    map?.resize();
  }, [map, isDrawerOpened]);
}
